import type { User } from "@/api/user.service";

export function getLoggedUser() {
  var jsonString = localStorage.getItem("user");

  if (!jsonString) return null;

  return JSON.parse(jsonString) as User
}